import {throwError} from 'rxjs';
import {ActivatedRouteSnapshot} from '@angular/router';
import {AppNameEnum} from '@nachdigal';
import {NavigationItem, stageName} from '@common-ui-lib';
import {environment} from '../../../environments/environment';

export class ComponentHelper {

  public static getNutzdatenPath(route: ActivatedRouteSnapshot): string {
    const map = new Map(Object.entries(route.component));
    if (!map.has('nutzdatenPath')) {
      throwError('nutzdatenPath not set');
      map.set('nutzdatenPath', undefined);
    }
    return map.get('nutzdatenPath');
  }

  public static getAppEnum(route: ActivatedRouteSnapshot): AppNameEnum {
    return this.pathToAppNameEnum(route.root.firstChild?.routeConfig.path);
  }

  public static pathToAppNameEnum(route: string): AppNameEnum {
    if (route === 'fragebogen-eun') {
      return AppNameEnum.FragebogenEUn;
    }
    if (route === 'fragebogen-kap-ges') {
      return AppNameEnum.FragebogenKapG;
    }
    if (route === 'fragebogen-pers-ges') {
      return AppNameEnum.FragebogenPersG;
    }
    if (route === 'fragebogen-betpg') {
      return AppNameEnum.FragebogenBetPG;
    }
    if (route === 'fragebogen-kapg-aus') {
      return AppNameEnum.FragebogenKapGAus;
    }
    return undefined;
  }


  public static flattenNavigationPages(navigationItems: Array<NavigationItem>): Array<NavigationItem> {
    const pages = [];
    navigationItems.forEach(item => {
      if (item.items?.length > 0) {
        item.items.forEach(subItem => {
          if(this.isVisible(item) && this.isVisible(subItem)) {
            pages.push(subItem);
          }
        });
      } else {
        if(this.isVisible(item)) {
          pages.push(item);
        }
      }
    });
    return pages;
  }

  public static isVisible(navItem : NavigationItem) : boolean{
    if( navItem.onlyVisibleOn === undefined || navItem.onlyVisibleOn.length === 0 ) {
      return true;
    } else if(navItem.onlyVisibleOn.includes(environment.name as stageName)) {
      return true;
    } else {
      return false;
    }
  }
}
